
<div class="file-upload">  
    <div class="container" dlAppDnd (fileDropped)="onFileDroppedandSelect($event[0])">
      <ng-container *ngIf="showFileInput">
    <input type="file" #fileDropRef id="fileDropRef" style="display: none;cursor: pointer;"  (change)="onFileDroppedandSelect($event)"  accept=".xlsx, .xls, .csv" />
    </ng-container>
    <span class="dl-svg-img"></span>
  <span>Drag item here or<label for="fileDropRef">Upload</label> the file</span>     
    <!-- star -->
    <div class="files-list" *ngFor="let file of files; let i = index">
      <div class="single-file">      
        <div class="info">
          <owc-icon class="one-icons"  style="cursor: pointer; width: 21.33px;height: 26.67px;">file_excel</owc-icon>
          <span style="margin-left:20px">
          <span class="name">
            {{ file?.name }}
          </span>
          <p class="size">
            {{ formatBytes(file?.size) }}
          </p>
        </span>       
        </div>    
        <owc-icon class="one-icons" (click)="deleteFile(i)" style="cursor: pointer; width: 14px;
        height: 18px;padding-bottom: 9px;">delete_outline</owc-icon>  
      </div>
    </div>
    <!-- end -->
  </div>
  
  </div>
  